import store from '../store'

const containsAny = function (list1, list2) {
    return list1 && list2 && list1.some(item => list2.includes(item))
}

const roleMixins = {
    methods: {
        hasRole: function (role) {
            const userRoles = store.state.App.roles
            return userRoles && userRoles.includes(role)
        },
        hasAnyRole: function (roles) {
            if(!roles) {
                return true
            }
            const userRoles = store.state.App.roles
            return userRoles && containsAny(roles, userRoles)
        }
    }
}

export default roleMixins